export const ID = 'cb333f09-57ea-47fb-8c09-0643a0be9a15';

export const NAME = 'StorageMart Esign storEDGE';
